import { call, put, takeEvery } from "redux-saga/effects";

// Calender Redux States
import {
  ADD_NEW_PATIENTS,
  DELETE_PATIENTS,
  GET_PATIENTS,
  GET_PATIENTS_DETAILS,
  UPDATE_PATIENTS,
} from "./actionTypes.js";

import {
  addPatientsFail,
  addPatientsSuccess,
  deletePatientsFail,
  deletePatientsSuccess,
  getPatientsDetailsFail,
  getPatientsDetailsSuccess,
  getPatientsFail,
  getPatientsSuccess,
  updatePatientsFail,
  updatePatientsSuccess,
} from "./actions.js";

import {
  addNewPatients,
  patientsDetailsApi,
  patientsListingApi,
  delPatients,
  updatePatients,
} from "./patientApi.js";

function* fetchPatients({ payload: length, sort, page, IC, sort_by }) {
  try {
    const response = yield call(patientsListingApi, length, sort, page, IC, sort_by)
    yield put(getPatientsSuccess(response))
  } catch (error) {
    yield put(getPatientsFail(error))
  }
}
function* fetchPatientsDetails({ payload: id }) {
  try {
    const response = yield call(patientsDetailsApi, id)
    yield put(getPatientsDetailsSuccess(response))
  } catch (error) {
    yield put(getPatientsDetailsFail(error))
  }
}

function* onAddNewPatients({ payload: patients }) {
  try {
    const response = yield call(addNewPatients, patients)
    yield put(addPatientsSuccess(response))
  } catch (error) {
    yield put(addPatientsFail(error))
  }
}

function* onUpdatePatients({ payload: id, patients }) {
  try {
    const response = yield call(updatePatients, id, patients)
    yield put(updatePatientsSuccess(response))
  } catch (error) {
    yield put(updatePatientsFail(error))
  }
}

function* onDelPatients({ payload: id }) {
  try {
    const response = yield call(delPatients, id)
    yield put(deletePatientsSuccess(response))
  } catch (error) {
    yield put(deletePatientsFail(error))
  }
}


function* PatientsSaga() {
  yield takeEvery(GET_PATIENTS, fetchPatients)
  yield takeEvery(GET_PATIENTS_DETAILS, fetchPatientsDetails)
  yield takeEvery(ADD_NEW_PATIENTS, onAddNewPatients)
  yield takeEvery(UPDATE_PATIENTS, onUpdatePatients)
  yield takeEvery(DELETE_PATIENTS, onDelPatients)
}

export default PatientsSaga
